/* global Vue, VueI18n, BOOKING_APP_URI, PREFIX */

import { formatDateForMaistra } from 'scripts/utils-common'
import { useCurrencyObserver, changeTextCurrency } from '../../use-currency-observer'
import CldImg from './CldImg'
import AuthService from '../../AuthService'
import { BookingParamsFromVariation } from '../../classes/BookingParams'

export default {
  name: 'OfferCard',
  components: { CldImg },
  template: `
    <div class="offer-card" :class="{
        'offer-card--recommended': offer.recommended,
        'offer-card--wide': isWide,
        'offer-card--middle': isMiddle,
      }">
      <a v-if="offer.image" class="offer-card__image" :href="offer.link" :title="offer.title">
        <CldImg :src="offer.image" :alt="offer.title" :setHeight="true" />
      </a>

      <div class="offer-card__content">
        <div class="offer-card__discount" v-if="offer?.teaser?.trim()">{{ teaser }}</div>
        <div class="offer-card__recommended" v-if="offer.recommended">{{ $t('offers.recommended') }}</div>

        <div>
          <a class="h3" :href="offer.link">
            {{ offer.title }}
          </a>
        </div>

        <div class="offer-card__destinations" v-if="offer.properties.length === 1 || distinctDestinations">
          <span class="offer-card__teaser">
            <i v-if="offer.properties.length === 1" class="icon-pin"></i>
            {{ offer.properties.length === 1 ? offer.properties[0].split('-').join(' ') : '' }}
            <template v-if="offer.properties.length === 1 && distinctDestinations"><span class="offer-card__separator"></span></template>
            {{ distinctDestinations }}
          </span>
        </div>
        <span v-if="dateString" class="offer-card__teaser offer-card__teaser--period" v-html="$t('offers.period') + ' ' + dateString"></span>

        <p class="no-margin-top">{{ offer.description }}</p>

        <div class="offer-card__buttons">
          <a class="button button--outline" :href="getOfferUrl(offer)" >{{ $t('bookNow') }}</a>
          <a class="arrow-button" :href="offer.link">
            {{ $t('discoverMore') }}
            <i class="icon-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  `,
  props: {
    offer: Object,
    isWide: Boolean,
    isMiddle: Boolean,
  },
  setup (props) {
    const { t } = VueI18n.useI18n()
    const teaser = Vue.ref('')
    const distinct = new Set()
    const loginHint = Vue.ref('')
    const distinctDestinations = props.offer.destinations?.filter((item) => {
      return distinct.has(item) ? false : (distinct.add(item))
    }).join(' | ') || ''

    const dateString = Vue.computed(() => {
      if (props.offer.periodsText) {
        return `${t('offers.period')} <strong>${props.offer.periodsText}</strong>`
      }

      if (props.offer.periods && props.offer.periods.length) {
        return '<strong>' + props.offer.periods
          .map(p => `${formatDateForMaistra(new Date(p.start_date))} - ${formatDateForMaistra(new Date(p.end_date))}`)
          .join(' | ') + '</strong>'
      }

      return `<strong>${formatDateForMaistra(new Date(props.offer.startDate))} - ${formatDateForMaistra(new Date(props.offer.endDate))}</strong>`
    })

    const currency = useCurrencyObserver()
    Vue.watch(currency, () => {
      const sourceTeaser = props.offer.teaser
      teaser.value = changeTextCurrency(sourceTeaser)
    }, { immediate: true })

    function getOfferUrl (offer) {
      if (offer.variations.length === 1 && offer.variations[0].phobsId) {
        const bookingParams = Vue.reactive(new BookingParamsFromVariation(offer.variations[0], loginHint.value))
        return `${BOOKING_APP_URI}${PREFIX}/step1/?propertyId=${offer.variations[0].phobsId}` +
        `&${bookingParams.urlString}&currency=${currency.value}`
      }

      return offer.link + '#/#variations'
    }

    Vue.onMounted(async () => {
      AuthService.on('authenticated', e => {
        loginHint.value = `${e.detail.loginHint}`
      })
    })

    return {
      getOfferUrl,
      dateString,
      distinctDestinations,
      teaser,
    }
  },
}
